import React, { useState } from 'react';

const Solutions = () => {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <div className="relative bg-white">
      {/* Content */}
      <div className="relative z-10 px-4 md:px-20 pb-10 md:pt-5 pt-1">
        {/* Heading */}
        <div className="mt-2 md:mt-2 md:mb-5 mb-2">
          <h1 className="text-[12px] md:text-[36px] font-bold text-[#FDBD26] md:mb-3">
            Experience Farmnet App
          </h1>
          <h1 className="text-[12px] md:text-[40px] font-bold text-black">
            Records
          </h1>
        </div>

        {/* Records Section */}
        <div className="bg-[#2E453D] rounded-md w-full md:h-[630px] h-[175px] relative flex items-center justify-center p-2 md:p-0 pt-2mt-4">
          <div className="rounded-xl overflow-hidden relative w-full h-[300px] md:mt-5 md:h-[700px] flex justify-center items-center cursor-pointer">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744548246/image_qw0fkn.png"
              alt="Mobile"
              className="object-cover w-[20%] h-[50%] md:w-[22%] md:h-[83%] object-center"
            />
            {/* Play Icon */}
            <div
              onClick={() => setShowVideo(true)}
              className="absolute inset-0 flex justify-center items-center cursor-pointer"
            >
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
                alt="Play Icon"
                className="w-[50px] h-[50px] md:w-[110px] md:h-[110px] object-contain"
              />
            </div>
          </div>

          <div className="absolute bottom-[10px] md:bottom-8 left-4 md:left-10 text-[#FDBD26]">
            <p className="text-[12px] md:text-[43px] font-bold text-[#FDBD26]">Records</p>
          </div>

          {/* Logo */}
          <div className="absolute left-4 md:left-6 top-0 md:top-4 w-[60px] md:w-[200px] h-[50px] md:h-[80px] z-10">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744195055/image_14_o9yorx.png"
              alt="Logo"
              className="w-full h-full object-contain"
            />
          </div>
        </div>

        {/* Description */}
        <div className='md:text-[32px] text-[10px] font-normal md:mt-16 mt-2 space-y-6'>
          <div className="md:mb-10 mb-3" style={{ lineHeight: '1.30' }}>
            The Farmnet Mobile App is a comprehensive digital tool designed to assist farmers in managing their agricultural activities efficiently. By digitizing record-keeping, it offers several benefits that enhance farm operations:
          </div>

          <div className="md:mb-10 mb-3">
            <strong>Benefits of Using the Farmnet App for Record-Keeping</strong>
          </div>
          <div className='md:h-2'></div>
          <div style={{ lineHeight: '1.20' }}>
            <div className="" style={{ lineHeight: '1.30' }}>
              <strong>1. Enhanced Efficiency:</strong> The app allows farmers to record data in real-time, reducing the time spent on manual documentation and minimizing errors associated with traditional methods.
            </div>

            <div className="" style={{ lineHeight: '1.30' }}>
              <strong>2. Improved Farm Management:</strong> With features like crop tracking, livestock monitoring, and input management, the app helps farmers make informed decisions, leading to optimized resource use and increased productivity.
            </div>

            <div className="" style={{ lineHeight: '1.30' }}>
              <strong>3. Compliance and Reporting:</strong> The app facilitates easy tracking of activities such as pesticide application and fertilizer use, aiding in compliance with agricultural regulations and standards.
            </div>

            <div className="" style={{ lineHeight: '1.30' }}>
              <strong>4. Financial Oversight:</strong> By recording expenses and revenues, the app provides insights into farm profitability, assisting in budgeting and financial planning.
            </div>

            <div className="" style={{ lineHeight: '1.30' }}>
              <strong>5. Accessibility and Collaboration:</strong> Farmers can access their records from anywhere, enabling remote management and collaboration with team members or advisors.
            </div>

            <div className="md:mt-20 mt-5" style={{ lineHeight: '1.30' }}>
              Farmnet Mobile App streamlines record-keeping processes, offering farmers a digital solution that enhances efficiency, management, and profitability.
            </div>
          </div>
        </div>

        <div className='md:h-10 h-5'></div>
      </div>

      {/* Video Modal */}
      {showVideo && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-90 flex justify-center items-center">
          <div className="relative w-[90%] max-w-4xl">
            <button
              onClick={() => setShowVideo(false)}
              className="absolute top-2 right-4 text-white text-4xl font-bold z-10"
            >
              &times;
            </button>
            <video
              src="https://res.cloudinary.com/dzngpgki4/video/upload/v1744223779/c7sxptbabat73g75fjl7.mp4"
              controls
              autoPlay
              className="w-full max-h-[90vh] rounded-xl"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Solutions;
